export const NamespaceConfig = {
  domain: {
    path: ["domain", "path"],
  },

  subdomain: {
    path: ["domain", "path", -1],
  },
}
